import { Fragment, useState } from "react";
import { Outlet } from "react-router-dom";
import Header from "../Header/Header";
import { Progress } from "@chakra-ui/react";

const HomeLayout = () => {
  const [hasStripe, setHasStripe] = useState(false);
  const [progressValue, setProgressValue] = useState(0);
  return (
    <Fragment>
      {progressValue > 0 && (
        <Progress
          hasStripe={hasStripe}
          isAnimated
          value={progressValue}
          size="xs"
        />
      )}
      <div style={{position: "fixed", width:"100vw", backgroundColor: "#FFFFFF", zIndex: "1"}}>
        <Header />
      </div>
      <div style={{ padding: "90px 30px 30px 30px" }}>
        <Outlet context={[setHasStripe, setProgressValue]} />
      </div>
    </Fragment>
  );
};

export default HomeLayout;
